export const T = {
  en_GB: { noPortfolioCostsConfigured: "No portfolio costs configured for this collection." },
  nb_NO: {
    noPortfolioCostsConfigured: "Ingen porteføljekostnader konfigurert for denne samlingen.",
  },
} as const;
